import React from 'react'

type CourseFeatureProps = {
  title: string
  description: string
  icon: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const CourseFeature = ({
  title,
  description,
  icon,
  ...props
}: CourseFeatureProps) => {
  const CustomIcon = React.cloneElement(icon as React.ReactElement, {
    className: 'w-5 h-5',
  })

  return (
    <div
      {...props}
      className={`flex font-medium bg-grey-background p-4 items-start gap-2 rounded-2xl ${props.className ?? ''}`}
    >
      {CustomIcon}
      <div className="flex flex-col leading-5">
        <dt className="text-sm first-letter:capitalize text-mydra-black">
          {title}
        </dt>
        <dd className="text-xs text-gray-light">{description}</dd>
      </div>
    </div>
  )
}
